module.exports = __webpack_public_path__ + "static/media/question-solid.dbec4a64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question-solid.svg
// module id = 264
// module chunks = 0